export default {
    name: 'QCheckbox',
    model: {
        prop: 'checked',
        event: 'change'
    },
    props: {
        value: {
            default: false
        },
        checked: {
            default: false
        },
        text: {
            type: String,
            default: ''
        },
        icon: {
            type: String,
            default: 'check'
        },
        // size of checkbox-display, e.g. 20px, 50%
        size: {
            type: String,
            default: '20px'
        }
    },
    computed: {
        checkboxSize() {
            return `width: ${this.size}; height: ${this.size};`;
        },
        isChecked() {
            if (this.checked.constructor === Array) {
                return this.checked.includes(this.value);
            } else {
                return this.checked;
            }
        }
    },
    methods: {
        checkItem() {
            // handle v-modeled arrays
            if (this.checked.constructor === Array) {
                const index = this.checked.indexOf(this.value);
                if (index !== -1) {
                    this.checked.splice(index, 1);
                } else {
                    this.checked.push(this.value);
                }
                this.$emit('change', this.checked);
                // handle v-modeled booleans
            } else if (typeof this.value === 'boolean') {
                this.checked = !this.checked;
                this.$emit('change', this.checked);
                // handle all other v-modeled data types
            } else {
                this.checked = !this.checked;
                if (this.checked === false) {
                    this.$emit('change', '');
                } else {
                    this.$emit('change', this.value);
                }
            }
        }
    }
};
